import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

export const StyledDropdownIndicator = styled(InnerComponent).attrs({ Component: components.DropdownIndicator })`
  && {
    box-sizing: content-box;
    color: ${props => props.selectProps.isDisabled ? colors.secondary80 : colors.secondary40};
    padding: 0 3px 0 0;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`

const DropdownIndicator = (props) => {
  if (props.options?.length === 1) {
    return null
  }

  return (
    <StyledDropdownIndicator {...props} />
  )
}

DropdownIndicator.propTypes = {
  options: PropTypes.array,
}

export default DropdownIndicator
